import { useCallback } from "react";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import { useAuth } from "@/hooks/useAuth";
export default function App() {
  const { auth, setAuth, refresh, logout } = useAuth();
  const handleUnauthorized = useCallback(() => {
    setAuth({ status: "signed-out" });
  }, [setAuth]);
  if (auth.status === "checking") {
    return (
      <div className="flex min-h-screen items-center justify-center bg-void">
        <span className="font-mono text-xs uppercase tracking-widest text-ink-faint">Loading console...</span>
      </div>
    );
  }
  if (auth.status === "signed-out") {
    return <Login onSuccess={() => void refresh()} />;
  }
  return <Dashboard onLogout={() => void logout()} onUnauthorized={handleUnauthorized} />;
}
